import Button from 'devextreme-react/button';
import Popup from 'devextreme-react/popup';
import { useResponsivePopupOptions } from '@jarvis/platform-ui';
import { timeOffDetailSection } from './timeOffEntryPopupStyles';

export type TimeOffSubmitResult =
  | { kind: 'success'; count: number; message?: string; againText?: string }
  | { kind: 'failed'; message: string };

export function createdTimeOffMessage(count: number): string {
  return `Created ${count} time off ${count === 1 ? 'entry' : 'entries'}.`;
}

export function importedTimeOffMessage(inserted: number, errorCount = 0): string {
  const imported = `Imported ${inserted} time off ${inserted === 1 ? 'entry' : 'entries'}.`;
  if (errorCount <= 0) return imported;
  return `${imported} ${errorCount} row(s) need attention below.`;
}

interface TimeOffSubmitResultPopupProps {
  result: TimeOffSubmitResult | null;
  onClose: () => void;
  onGoToCalendar: () => void;
}

export function TimeOffSubmitResultPopup({
  result,
  onClose,
  onGoToCalendar
}: TimeOffSubmitResultPopupProps) {
  const popupOptions = useResponsivePopupOptions({ width: 440, height: 'auto' });
  const visible = result != null;
  const failed = result?.kind === 'failed';
  const title = failed ? 'Failed' : 'Success';
  const message =
    result?.kind === 'success'
      ? (result.message ?? createdTimeOffMessage(result.count))
      : (result?.message ?? '');
  const againText = result?.kind === 'success' ? (result.againText ?? 'Add another') : 'Add another';

  return (
    <Popup
      visible={visible}
      onHiding={onClose}
      title={title}
      showCloseButton
      dragEnabled
      width={popupOptions.width}
      height={popupOptions.height}
      fullScreen={popupOptions.fullScreen}
      deferRendering={false}
      shading
      contentRender={() => (
        <div
          style={{
            padding: '0.5rem 0.75rem 0.75rem',
            display: 'flex',
            flexDirection: 'column',
            gap: '1rem'
          }}
        >
          <div style={timeOffDetailSection}>
            <p style={{ margin: 0, lineHeight: 1.45 }}>{message}</p>
          </div>
          <div style={{ display: 'flex', gap: '0.5rem', flexWrap: 'wrap', justifyContent: 'flex-end' }}>
            {failed ? (
              <Button text="OK" type="default" stylingMode="contained" onClick={onClose} />
            ) : (
              <>
                <Button text={againText} stylingMode="outlined" onClick={onClose} />
                <Button
                  text="Calendar view"
                  type="default"
                  stylingMode="contained"
                  onClick={onGoToCalendar}
                />
              </>
            )}
          </div>
        </div>
      )}
    />
  );
}
